<template>
  <div>
    <ul
      class="toggle-switch"
      :class="{'square' : defaultOptions.layout.squareCorners}"
      :style="toggleSwitchStyle"
    >
      <li
          v-for="(label, index) in defaultOptions.items.labels"
          :key="index"
          :style="itemStyle"
      >
        <input
            :id="label.name + group"
            :disabled="defaultOptions.items.disabled || disabled"
            :value="selectedItem[label.name]"
            :name="name"
            type="checkbox"
            @click="toggle(label.name)"
            :checked="selectedItem[label.name] === true"
            :indeterminate="selectedItem[label.name] === null"
        >
        <label
            :style="getLabelStyle(label)"
            :class="{ active: !defaultOptions.items.disabled || disabled }"
            class="selected"
            :for="label.name + group"
            :title="getLabelTitle(label)"
            v-html="label.ico"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import log from "echarts/src/scale/Log";

const s = x => x + 's'
const rem = v => v + 'rem'

export default {
  props: {
    options: {
      type: Object,
      required: false
    },
    value: {
      type: Object,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    group: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      selected: false,
      selectedItem: {},
      defaultOptions: Object
    }
  },
  computed: {
    toggleSwitchStyle () {
      return {
        width: rem(this.defaultOptions.size.width),
        height: rem(this.defaultOptions.size.height)
      }
    },
    itemStyle () {
      return {
        width: rem(this.defaultOptions.size.width),
        height: rem(this.defaultOptions.size.height),
        fontFamily: this.defaultOptions.layout.fontFamily,
        fontSize: rem(this.defaultOptions.size.fontSize),
        textAlign: 'center'
      }
    },
    labelStyle () {
      return {
        padding: rem(this.defaultOptions.size.padding),
        borderColor: this.defaultOptions.layout.noBorder ? 'transparent' : this.defaultOptions.layout.borderColor,
        backgroundColor: this.defaultOptions.layout.backgroundColor,
        color: this.defaultOptions.layout.color,
        fontWeight: this.defaultOptions.layout.fontWeight,
        transition: s(this.defaultOptions.items.delay)
      }
    }
  },
  watch: {
    value (val) {
      this.selectedItem = val
    },
    options (val) {
      if (val !== null && val !== undefined) {
        this.mergeDefaultOptionsWithProp(val)
      }
    }
  },
  created () {
    this.defaultOptions = {
      layout: {
        color: 'black',
        backgroundColor: 'gainsboro',
        selectedColor: 'white',
        selectedBackgroundColor: '#FFC0A4',
        borderColor: 'lightgray',
        fontFamily: 'Roboto',
        fontWeight: 'normal',
        fontWeightSelected: 'normal',
        squareCorners: false,
        noBorder: false
      },
      size: {
        fontSize: 1,
        height: 3.25,
        padding: 0.5,
        width: 12
      },
      items: {
        delay: 0.4,
        preSelected: 'unknown',
        disabled: false,
        labels: [
          {
            ico: '<span class="mdi mdi-access-point online"></span>',
            name: 'online',
            title: {
              "1": `${this.translate('filter.status.device.title')} ${this.translate('filter.status.device.online')}`,
              "-1": `${this.translate('filter.status.device.title')} ${this.translate('filter.status.device.offline')}`,
              "0": `${this.translate('filter.status.device.title')} ${this.translate('filter.status.device.any')}`,
            },
            color: 'black',
            backgroundColor: {
              "1": '#ABF3CB',
              "-1": '#f3abd3'
            }
          },
          {
            ico: '<span class="mdi mdi-lock-alert blocked"></span>',
            name: 'blocked',
            title: {
              "1": `${this.translate('filter.status.blocked.title')} ${this.translate('filter.status.blocked.blocked')}`,
              "-1": `${this.translate('filter.status.blocked.unblocked')} ${this.translate('filter.status.blocked.unblocked')}`,
              "0": `${this.translate('filter.status.blocked.title')} ${this.translate('filter.status.blocked.any')}`,
            },
            color: 'black',
            backgroundColor: {
              "1": '#ffa4a4',
              "-1": '#a4ffff'
            }
          },
        ]
      }
    }
  },
  mounted () {
    if (this.options !== null && this.options !== undefined) {
      this.mergeDefaultOptionsWithProp(this.options)
    }
    this.selectedItem = this.value

    if (this.$store.getters.getPermissions.viewCommerceData === true){
      this.defaultOptions.items.labels.push(
        {
          ico: '<span class="mdi mdi-currency-rub tariffication"></span>',
          name: 'tariffication',
          title: {
            "1": `${this.translate('filter.status.tariffication.title')} ${this.translate('filter.status.tariffication.charged')}`,
            "-1": `${this.translate('filter.status.tariffication.title')} ${this.translate('filter.status.tariffication.not_charged')}`,
            "0": `${this.translate('filter.status.tariffication.title')} ${this.translate('filter.status.tariffication.any')}`,
          },
          color: 'black',
          backgroundColor: {
            "1": '#abd7f3',
            "-1": '#f3c7ab'
          }
        }
      )
    }

    if (this.$store.getters.getPermissions.viewDeviceBackupStatus === true){
      this.defaultOptions.items.labels.push(
        {
          ico: '<span class="mdi mdi-server-network backup"></span>',
          name: 'backup',
          title: {
            "1": `${this.translate('filter.status.backup.title')} ${this.translate('filter.status.backup.enabled')}`,
            "-1": `${this.translate('filter.status.backup.title')} ${this.translate('filter.status.backup.disabled')}`,
            "0": `${this.translate('filter.status.backup.title')} ${this.translate('filter.status.backup.any')}`,
          },
          color: 'black',
          backgroundColor: {
            "1": '#ffd5a4',
            "-1": '#a4ceff'
          }
        }
      )
    }
  },
  methods: {
    getLabelTitle(label){
      return label.title[this.selectedItem[label.name]]
    },
    toggle (name) {
      if (this.selectedItem[name] === 0) {
        this.selectedItem[name] = -1;
      } else if (this.selectedItem[name] === -1) {
        this.selectedItem[name] = 1;
      } else {
        this.selectedItem[name] = 0;
      }
      this.$emit('toggle', name, this.selectedItem[name]);
    },
    labelStyleSelected (color, backgroundColor) {
      return {
        padding: rem(this.defaultOptions.size.padding),
        borderColor: this.defaultOptions.layout.noBorder ? 'transparent' : this.defaultOptions.layout.borderColor,
        fontWeight: this.defaultOptions.layout.fontWeightSelected,
        backgroundColor: backgroundColor !== undefined ? backgroundColor : this.defaultOptions.layout.selectedBackgroundColor,
        color: color !== undefined ? color : this.defaultOptions.layout.selectedColor,
        transition: s(this.defaultOptions.items.delay)
      }
    },
    getLabelStyle (label) {
      if (this.selectedItem[label.name] === 0) {
        return {
          ...this.labelStyle,
          backgroundColor: '#e0e0e0',
          color: 'black',
        };
      }
      return this.selectedItem[label.name]
          ? this.labelStyleSelected(label.color, label.backgroundColor[this.selectedItem[label.name]])
          : this.labelStyle;
    },
    mergeDefaultOptionsWithProp (options) {
      var result = this.defaultOptions
      for (var option in options) {
        if (options[option] !== null && typeof (options[option]) === 'object') {
          for (var subOption in options[option]) {
            if (options[option][subOption] !== undefined && options[option][subOption] !== null) {
              result[option][subOption] = options[option][subOption]
            }
          }
        } else {
          result[option] = options[option]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul.toggle-switch {
  list-style: none;
  vertical-align: middle;
}
.toggle-switch label {
  margin: 0;
  font-size: 16px;
  line-height: 120%;
  &.neutral {
    background-color: #e0e0e0; /* или любой другой цвет для нейтрального состояния */
    color: #888888;
  }
}
.toggle-switch label{
  color: #000000;
}
.toggle-switch label > * {
  vertical-align: middle;
}
.toggle-switch {
  padding: 0;
  margin: 0;
  display: inline-flex;
}
.toggle-switch li {
  position:relative;
  margin: 0;
  line-height: 1.15em;
}
.toggle-switch li:first-child label {
  border: 1px solid;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.toggle-switch li:last-child label {
  border-right: 1px solid;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.toggle-switch label, .toggle-switch input {
  display:block;
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
}
.toggle-switch input[type="checkbox"] {
  opacity:0.01;
}
.toggle-switch li:not(:first-child):not(:last-child) label {
  border-right: 1px solid;
  border-top: 1px solid;
  border-bottom: 1px solid;
}
.active {
  cursor: pointer;
}
</style>
